var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.29537522,4.39382724 L12,10.098 L17.7046309,4.39382596 C18.229723,3.86873386 19.0810635,3.8687154 19.6061744,4.39382627 C20.1312853,4.91893715 20.131266,5.77027669 19.6061739,6.2953688 L13.902,12 L19.6061768,17.7046288 C20.1312689,18.2297209 20.1312881,19.0810605 19.6061715,19.606177 C19.0810606,20.1312879 18.2297201,20.1312694 17.704628,19.6061773 L12,13.902 L6.29537237,19.6061704 C5.77028007,20.1312627 4.91893965,20.131281 4.39382877,19.6061701 C3.8687179,19.0810593 3.86873702,18.2297198 4.39382931,17.7046275 L10.098,12 L4.39382646,6.29537578 C3.86873416,5.77028349 3.86871504,4.91894404 4.39382592,4.39383316 C4.9189425,3.86871658 5.77028292,3.86873494 6.29537522,4.39382724 Z","id":"Path-2"}));
}

Close.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Close;

Close.default = Close;
